import { useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Button } from 'core-components/library/button'
import { ITableProps } from 'core-components/library/list/types'
import { BaseCrud } from 'core-components/types'

import { EditItemContentModal } from './EditItemContentModal'

interface ICreateItemContentButton {
  columns: ITableProps['columns']
  source: BaseCrud
}

export const CreateItemContentButton = ({ columns, source }: ICreateItemContentButton) => {
  const [item, setItem] = useState<IForm | null>(null)

  const createItem = () => {
    const newItem: IForm = {}
    for (const column of columns) {
      newItem[column.field] = ''
    }
    setItem(newItem)
  }

  return (
    <>
      <Button onClick={createItem} icon={'kbase kbase-add'}>
        Create new item
      </Button>
      {item ? (
        <EditItemContentModal
          item={item}
          columns={columns}
          onClose={() => setItem(null)}
          source={source}
        />
      ) : null}
    </>
  )
}
